import { Injectable } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';

import { Environment } from '@app/common/interfaces';


@Injectable({
  providedIn: 'root',
})
export class EnvironmentData {

  constructor(private _api: FsApi) { }

  public create(data: Environment = { id: null }): Environment {
    data.address = data.address || {};

    return data;
  }

  public save(data, config: RequestConfig = {}): Observable<any> {
    if (data.id) {
      return this.put(data, config);
    }

    return this.post(data, config);
  }

  public get(environmentId, data: any = {}): Observable<any> {
    return this._api.get(`environments/${environmentId}`, data, { key: 'environment' });
  }

  public gets(data: any = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', 'environments', data, { key: 'environments', ...config });
  }

  public put(environment, config: RequestConfig = {}): Observable<any> {
    return this._api.put(`environments/${environment.id}`, environment, { key: 'environment', ...config });
  }

  public post(environment, config: RequestConfig = {}): Observable<any> {
    return this._api.post('environments', environment, { key: 'environment', ...config });
  }

  public delete(environment): Observable<any> {
    return this._api.delete(`environments/${environment.id}`, environment, { key: 'environment' });
  }

  public switch(accountId: number, environmentId: number): Observable<any> {
    return this._api.put(`accounts/${accountId}/environments/${environmentId}/switch`, null, { key: 'environment' });
  }

  public image(environment, file): Observable<any> {
    return this._api.post(`environments/${environment.id}/image`, { file }, { key: 'environment' });
  }

  public deleteAccounts(environmentId: number, data: any = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.delete(`environments/${environmentId}/accounts/${data.id}`,
      data, { key: 'objectAccount', ...config });
  }

  public diseasesPost(environmentId: number, data: any = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.post(`environments/${environmentId}/diseases`,
      data);
  }

  public diseasePut(environmentDisease, config: RequestConfig = {}): Observable<any> {
    return this._api.put(`environments/${environmentDisease.environmentId}/diseases/${environmentDisease.diseaseId}`,
      environmentDisease, { key: 'environmentDisease' });
  }

  public diseaseGet(environmentId, diseaseId, config: RequestConfig = {}): Observable<any> {
    return this._api.get(`environments/${environmentId}/diseases/${diseaseId}`, {}, { key: 'environmentDisease' });
  }

  public diseaseFoundationsGets(environmentId, diseaseId, config: RequestConfig = {}): Observable<any> {
    return this._api.get(`environments/${environmentId}/diseases/${diseaseId}/foundations`, {}, { key: 'foundations' });
  }

  public diseaseFundsGets(environmentId, diseaseId, query, config: RequestConfig = {}): Observable<any> {
    return this._api.get(`environments/${environmentId}/diseases/${diseaseId}/funds`, query, { key: 'funds' });
  }
}
